<template>
  <div>
    <div class="content">
      <div class="all">
        <div class="SearchBar">
        <el-form :inline="true" class="searchBoxForm">
         
          <el-form-item label="年份:" class="searchItem">
            <el-date-picker
              size="mini"
              v-model="year"
              type="year"
              value-format="yyyy"
              placeholder="选择年">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="" class="searchItem">
             <el-button type="primary" @click="search" size="mini" >查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      </div>
      <div class="contain">
        <el-table
            ref="tableData"
            :data="tableData"
            style="width: 100%;margin-top: 10px ;"
            border
            show-summary
            :header-cell-style="{
							color: '#333',
							fontFamily: 'MicrosoftYaHeiUI',
							fontSize: '14px',
							fontWeight: 900,
							background: '#f8f8f9',
						}"
            :stripe="true"
          >
          <el-table-column
                prop="yue"
                label="月份"
                align="center"
            >
            </el-table-column>
           <el-table-column  :resizable="false" v-for="pi in headerData" :key="pi.id" :label="pi.stationName" align="center">
              <el-table-column :resizable="false" v-for="item in pi.children" :key="item.key" :label="item.name" :prop="item.key" align="center">
                <template slot-scope="scope">
                  {{ scope.row[item.key] }}
                </template>
              </el-table-column>
           </el-table-column>
           <el-table-column
                prop="heji"
                label="已完成合计"
                align="center"
            >
            </el-table-column>



         
        </el-table>
   
    </div>
    </div>
  </div>
</template>

<script>
import {stationStatistics} from "../../RequestPort/staticisc";
export default {
  data() {
    return {
      year:'',
      total:null,
      headerData:[],//[{id:1,stationName:'XX站',children:[{key:'yjc',name:'已检查数'},{key:'yjc2',name:'已完成数'}]},{id:2,stationName:'XX站',children:[{key:'yjc',name:'已检查数'},{key:'yjc2',name:'已完成数'}]}],
      tableData: [],//[{yue:'1月',yjc:20,yjc2:3},{yue:'2月',yjc:20,yjc2:3}], //  表格数据
      title:''
    };
  },
  mounted() {
  
			
		const date = new Date()
		this.year=date.getFullYear().toString()
    this.loadList()
  },
  methods: {
    
    search() {
      this.loadList();
    },

    loadList(){
      stationStatistics({years:this.year}).then(res=>{       
        
        let data=res.data.headerData       
        this.headerData = data.slice(0,data.length-1)
        this.tableData =res.data.tableData
        console.log(this.headerData)
      })
    },
   
    
  },
};
</script>

<style lang="scss" scoped>
.SearchBar .el-form, .searchBox .el-form{
width: auto;
}
.searchBox {
  .searchBoxForm {
    display: flex;
    align-items: center;
  }
}
.tableTool{    
  height: 25px;
}
.searchItem {
  margin-bottom: 1%;
  margin-left: 1%;
}
.label {
  color: #909399;
}
.content-item {
  color: #444444;
}
.SearchBar {
  border-radius: 5px;
  margin: 10px;
  padding-top: 1%;
  background-color: #ffffff;
}
.all {
  background-color:#f3f4f8;height:auto
}
.content {
  background: #f3f4f8;
  width: 100%;
  border-radius: 6px;
  overflow:auto;
  height: calc(100vh - 120px);
}
.search{
  width: 190px;
}
.contain{
  height: 677px;
}
.total{
  margin-left: 15px;
  margin-top: 10px;
}
.table{
  overflow:auto;
  height: 520px;
}
</style>